export enum AccountRestrictionStatus {
    RESTRICTED=1,
    UN_RESTRICTED=2
}


// WEBPACK FOOTER //
// ./src/app/common/enums/account-restricted.enum.ts